<dx-data-grid
            #gridArticoli     
            [dataSource]="dataSource"
             [showBorders]="true"
            [focusedRowEnabled]="false"
            [focusedRowIndex]="0"
            [allowColumnResizing]="true"
            [columnAutoWidth]="true"
            [columnResizingMode]="columnResizingMode"
            [showColumnLines]="true"
            [showRowLines]="true"
            [rowAlternationEnabled]="false"
            [allowColumnReordering]="true"
            [wordWrapEnabled]="false"
            (onRowPrepared)="onRowPrepared($event)"
            (onExporting)="onExporting($event)"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onRowDblClick)="goToDetail($event.data.id)"
            (onExporting)="onExporting($event)"
            (onContentReady)="onContentReady($event)">
            
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-paging [pageSize]="20"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [allowedPageSizes]="[10, 20, 50, 100]"></dxo-pager>
            <dxo-filter-row [visible]="false"></dxo-filter-row>
            <dxo-header-filter [visible]="true"  [allowSearch]="true"></dxo-header-filter>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
            <dxo-data-grid-selection mode="multiple" showCheckBoxesMode="always"></dxo-data-grid-selection>


    <dxo-data-grid-toolbar>

        <dxi-data-grid-item name="exportButton" location="after"></dxi-data-grid-item>

        <dxi-data-grid-item location="after">
            <dx-button (onClick)="stampaArticoli()" icon="print" text="Stampa Etichette" stylingMode="text">
            </dx-button>
        </dxi-data-grid-item>
    </dxo-data-grid-toolbar>

    <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="false" [allowDeleting]="true" [useIcons]="true">
        <dxo-texts confirmDeleteMessage="Confermare la cancellazione dell'articolo?"></dxo-texts>
    </dxo-editing>

    <dxi-column type="buttons" [width]="80">
        <dxi-button name="delete"></dxi-button>
    </dxi-column>

    <dxi-column name="detail§Anagra" [allowFiltering]="false" [allowSorting]="false" cellTemplate="detailArticolo"
        width="35" caption="">
    </dxi-column>
    <div *dxTemplate="let d of 'detailArticolo'">
        <i class="dx-icon-edit" (click)="goToDetail(d.data.id)" style="cursor: pointer;" data-toggle="tooltip"
            data-placement="top" title="Dettaglio articolo"></i>
    </div>
    <dxi-column dataField="attivo" caption="Attivo" dataType="boolean" width="60">
    </dxi-column>

    <dxi-column dataField="immateriale" caption="Immateriale" dataType="boolean" width="60">
    </dxi-column>

    <dxi-column dataField="gestioneKit" caption="Kit" dataType="boolean" width="60">
    </dxi-column>

    <dxi-column dataField="idTipo" caption="Tipologia" width="180" [calculateSortValue]="sortByLookup">
        <dxo-lookup [dataSource]="listTipiArticoli" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
    </dxi-column>

    <dxi-column dataField="idCategoria" caption="Categoria" width="180" [visible]="false">

    </dxi-column>

    <dxi-column dataField="codice" caption="Codice" width="130" [sortIndex]="1" sortOrder="asc">
    </dxi-column>

    <dxi-column dataField="descrizione" caption="Descrizione">
    </dxi-column>

    <dxi-column dataField="giacenza" caption="Giacenza" dataType="number" width="90">
    </dxi-column>

    <dxi-column dataField="taglia" caption="Taglia" width="90">
    </dxi-column>

    <dxi-column dataField="identificativo" caption="Identificativo" width="150">
    </dxi-column>

    <dxi-column dataField="note" caption="Note">
    </dxi-column>



</dx-data-grid>


<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="visibleLoadPanel" [showIndicator]="true"
    [showPane]="true" [shading]="true" [hideOnOutsideClick]="false" message="Stampa delle etichette">
</dx-load-panel>

@if(popupInfoBarCode){
<dx-popup [width]="600" [height]="250" [showTitle]="true" title="Informazioni Aggiuntive" [dragEnabled]="false"
    [hideOnOutsideClick]="true" [(visible)]="popupInfoBarCode">
    <app-popup-barcode (popupBarcodeEventEmitter)="onPopupBarcodeEventEmitter($event)"></app-popup-barcode>
</dx-popup>
}